import {Box, GlobalStyles, Link, Paper, Typography} from "@mui/material"
import React from "react"
import {useNavigate} from "react-router-dom"
import {AppButton} from "@app-core/AppButton"
import {useAuth} from "auth/AuthContext"
import {LOGO_BLUE, NAVY} from "theme"

export const HomeView: React.FC = () => {
  const navigate = useNavigate()
  const {user} = useAuth()

  const onStartCheck = () => {
    navigate("/eligibility")
  }

  const onPreviousAppClick = () => {
    navigate("/previous-applications")
  }

  const welcomeLine = user?.firstName
    ? `Welcome back, ${user.firstName}.`
    : "Welcome to Benefits2."

  return (
    <div>
      <GlobalStyles
        styles={() => ({
          "#dtc-toolbar": {position: "static"},
          "#dtc-footer": {position: "static"}
        })}
      />

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={1}
        marginBottom={2}
      >
        <Typography fontSize="20px" color={NAVY}>
          {welcomeLine}
        </Typography>
        {user && (
          <Link
            component="button"
            onClick={onPreviousAppClick}
            sx={{color: LOGO_BLUE, fontSize: "16px"}}
          >
            My Previous Applications
          </Link>
        )}
      </Box>

      {/* Primary card — whole card is clickable. (Resume-in-progress is a
          follow-up pending in-progress state; CTA is Start My Free Check.) */}
      <Paper
        elevation={0}
        onClick={onStartCheck}
        sx={{
          borderRadius: "27px",
          padding: {xs: 3, sm: 5},
          backgroundColor: "#fff",
          cursor: "pointer",
          border: `1px solid ${LOGO_BLUE}`
        }}
      >
        <Typography
          component="h1"
          fontWeight="bold"
          fontSize={{xs: "24px", sm: "28px"}}
          color={NAVY}
          marginBottom={2}
        >
          Check Your Benefits
        </Typography>
        <Typography
          fontSize="18px"
          color={NAVY}
          lineHeight={1.6}
          marginBottom={3}
        >
          Find out if you or someone you care for may qualify for the Disability
          Tax Credit. This takes about 5 minutes.
        </Typography>
        <AppButton
          onClick={(e) => {
            e.stopPropagation()
            onStartCheck()
          }}
          sx={{minWidth: "240px"}}
        >
          Start My Free Check
        </AppButton>
      </Paper>

      {/* Quick Start Guide (brief Screen 1) */}
      <Box sx={{marginTop: 4, marginBottom: "0"}}>
        <Paper
          elevation={0}
          sx={{
            borderRadius: "27px",
            padding: {xs: 3, sm: 5},
            backgroundColor: "#fff"
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontSize: {xs: "24px", sm: "28px"},
              fontWeight: "bold",
              color: NAVY,
              marginBottom: 2
            }}
          >
            Welcome to Benefits2.
          </Typography>
          <Typography
            sx={{
              fontSize: "18px",
              color: NAVY,
              lineHeight: 1.6,
              marginBottom: 3
            }}
          >
            {
              "We help Canadians find out if they or someone they care for may qualify for the Disability Tax Credit and related benefits."
            }
          </Typography>
          <Typography
            component="h3"
            sx={{
              fontSize: "22px",
              fontWeight: "bold",
              color: NAVY,
              marginBottom: 1
            }}
          >
            {"Here's how it works:"}
          </Typography>
          <Typography
            sx={{
              fontSize: "18px",
              color: NAVY,
              lineHeight: 1.6,
              marginBottom: 2
            }}
          >
            {
              "This short check asks about how your condition affects your daily life — things like getting dressed, preparing meals, walking, and managing your health. It takes about 5 minutes, and you don't need any documents to get started."
            }
          </Typography>
          <Typography
            sx={{
              fontSize: "18px",
              color: NAVY,
              lineHeight: 1.6,
              marginBottom: 2
            }}
          >
            {
              "If you qualify, we help you build a strong application. If you don't have a medical practitioner, yours is not supportive of your application, or you simply don't feel comfortable asking them, we can connect you with one."
            }
          </Typography>
          <Typography
            sx={{
              fontSize: "18px",
              color: NAVY,
              lineHeight: 1.6,
              fontWeight: "bold"
            }}
          >
            {
              "You can complete this for yourself, a spouse, a child, a parent, or anyone you care for."
            }
          </Typography>
        </Paper>
      </Box>
    </div>
  )
}

export default HomeView
